import {
  ApplicationRef,
  ComponentRef,
  EnvironmentInjector,
  Injectable,
  createComponent
} from '@angular/core';
import { ToastComponent } from '@app/notifications/toast/toast.component';

export class Toast {
  constructor(
    public id: string,
    public type: string,
    public items: { title: string; message: string }[],
    public icon?: string,
    public duration: number = 0
  ) {}

  get animationDelay(): number {
    return this.duration || Number.MAX_SAFE_INTEGER;
  }
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  _componentRef: ComponentRef<ToastComponent>;

  constructor(private appRef: ApplicationRef, private injector: EnvironmentInjector) {}

  public addToast(
    toastData: Toast,
    anchorElement?: HTMLElement,
    styles?: Map<string, Map<string, string>>
  ): void {
    // todo if componentRef already exists add data via subject?
    this._componentRef = this.createToastComponent(toastData);
    this._componentRef.setInput('styles', styles);

    const toastAnchor = anchorElement ? anchorElement : document.getElementById('content');

    toastAnchor.append(this._componentRef.location.nativeElement);
  }

  public removeToast(): void {
    if (!this._componentRef) return;

    this.appRef.detachView(this._componentRef.hostView);
    this._componentRef.destroy();
    this._componentRef = null;
  }

  private createToastComponent(toastData: Toast | Toast[]): ComponentRef<ToastComponent> {
    const componentRef = createComponent(ToastComponent, { environmentInjector: this.injector });
    const inputData = Array.isArray(toastData) ? toastData : [toastData];
    componentRef.setInput('toasts', inputData);
    // wires up change detection with the component
    this.appRef.attachView(componentRef.hostView);
    return componentRef;
  }
}
